import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hexToDecimal'
})
export class HexToDecimalPipe implements PipeTransform {

  transform(value: any): number {

    return parseInt(value, 16);;
  }

}
